import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbSrcOnError
})
export class KbSrcOnError extends Directive {
    constructor() {
        super();
        this.restrict = "A";
        this.link = (scope, element: JQuery, atts, ctrl, $transclude) => {
            element.on('error', () => {
                element.attr('src', atts.kbSrcOnError);
            });
        };
    }
}

